import React, { useEffect, useRef } from "react";
import { Box, Text } from "@chakra-ui/react";
import { TURNSTILE_SITE_KEY } from "utils/Constants";

const TURNSTILE_SCRIPT_ID = "cf-turnstile-script";
const TURNSTILE_SCRIPT_SRC =
  "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

function TurnstileCaptcha({ onTokenChange, resetSignal = 0 }) {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    const renderWidget = () => {
      if (
        cancelled ||
        !containerRef.current ||
        !window.turnstile ||
        widgetIdRef.current !== null
      ) {
        return;
      }

      widgetIdRef.current = window.turnstile.render(containerRef.current, {
        sitekey: TURNSTILE_SITE_KEY,
        callback: (token) => onTokenChange(token),
        "expired-callback": () => onTokenChange(""),
        "error-callback": () => onTokenChange(""),
      });
    };

    if (!window.turnstile) {
      const existingScript = document.getElementById(TURNSTILE_SCRIPT_ID);
      if (!existingScript) {
        const script = document.createElement("script");
        script.id = TURNSTILE_SCRIPT_ID;
        script.src = TURNSTILE_SCRIPT_SRC;
        script.async = true;
        script.defer = true;
        script.onload = renderWidget;
        document.body.appendChild(script);
      } else {
        existingScript.addEventListener("load", renderWidget, { once: true });
      }
    } else {
      renderWidget();
    }

    return () => {
      cancelled = true;
      if (window.turnstile && widgetIdRef.current !== null) {
        window.turnstile.remove(widgetIdRef.current);
        widgetIdRef.current = null;
      }
    };
  }, [onTokenChange]);

  useEffect(() => {
    if (window.turnstile && widgetIdRef.current !== null) {
      window.turnstile.reset(widgetIdRef.current);
      onTokenChange("");
    }
  }, [resetSignal, onTokenChange]);

  return (
    <Box mb="20px">
      <Text fontSize="sm" color="gray.500" mb="8px">
        Verify you are human
      </Text>
      <Box ref={containerRef} />
    </Box>
  );
}

export default TurnstileCaptcha;
